import { render, staticRenderFns } from "./RegisterEmail.vue?vue&type=template&id=4a0e4352&scoped=true"
import script from "./RegisterEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterEmail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RegisterEmail.vue?vue&type=style&index=0&id=4a0e4352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e4352",
  null
  
)

export default component.exports